import { isRight, left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';

import ReadUserGroupsClient from 'use-case/userGroups/read/readUserGroupsClient';
import { DashboardUserGroup, UserGroupLevel } from 'domain/entity/dashboard';

const readUserGroupsApiClient = (httpClient: httpClientFunction, baseUrl: string, itemsPerPage: number): ReadUserGroupsClient => () =>
    // eslint-disable-next-line no-async-promise-executor
    new Promise(async (resolve) => {
        let thereAreMoreValuesToRetrieve = true;
        let aggregatedUserGroups: DashboardUserGroup[] = [];

        while (thereAreMoreValuesToRetrieve) {
            // eslint-disable-next-line no-await-in-loop
            const result = await httpClient(`${baseUrl}/profiles?limit=${itemsPerPage}&start=${aggregatedUserGroups.length}`, {})
                .then((response) =>
                    response.ok
                        ? response
                              .json()
                              .then(asUserGroups)
                              .then(right)
                              .catch(() => left({ error: new Error(), status: 500 }))
                        : left({ error: new Error(), status: response.status })
                )
                .catch(() => left({ error: new Error(), status: 503 }));
            if (isRight(result)) {
                const userGroups = result.right;
                if (userGroups.length < itemsPerPage) thereAreMoreValuesToRetrieve = false;
                aggregatedUserGroups = aggregatedUserGroups.concat(userGroups);
            } else {
                return resolve(result);
            }
        }

        return resolve(right(aggregatedUserGroups));
    });

export type UserGroupJson = {
    id: number;
    name: string;
};

const asUserGroups = (userGroupsJson: UserGroupJson[]) =>
    userGroupsJson.map(
        (userGroupJson: UserGroupJson) => new DashboardUserGroup(userGroupJson.id.toString(), userGroupJson.name, UserGroupLevel.NONE)
    );

export default readUserGroupsApiClient;
